export interface Category {
  name: string;
  children?: Category[];
  action?: string;
  icon?: string;
  open?: boolean;
  roles?: string[];
}

export const CATEGORY_TREE: Category[] = [
  {
    name: 'Protocols',
    icon: 'protocol-icon',
    children: [
      {
        name: 'Cards',
        action: 'F5',
        icon: 'file-icon',
      },
      { name: 'Owners', action: '', icon: 'user-icon' },
      // {
      //   name: 'Serial number confirmation',
      //   action: '',
      //   icon: 'serial-number-icon',
      // },
      {
        name: 'Veterinarians',
        action: '',
        icon: 'user-icon',
      },
      { name: 'Clinics', action: '', icon: 'clinic-icon' },
      { name: 'Trainers', action: '', icon: 'user-icon' },
      { name: 'Groomers', action: '', icon: 'user-icon' },
      { name: 'Pet Transporters', action: '', icon: 'user-icon' },
      // { name: 'Excellent vaccinations', action: '', icon: 'clinic-icon' },
    ],
  },
  {
    name: 'Coders',
    icon: 'coder-icon',
    children: [
      {
        name: 'Suppliers',
        action: '',
        icon: 'manufacturers-medicaments-icon',
      },
      // {
      //   name: 'Serial number confirmation',
      //   action: '',
      //   icon: 'serial-number-icon',
      // },
      {
        name: 'Manufacturers of medicaments',
        action: '',
        icon: 'manufacturers-medicaments-icon',
      },
      {
        name: 'Medicaments',
        action: '',
        icon: 'type-medicaments-icon',
      },
      {
        name: 'Diagnoses',
        action: '',
        icon: 'types-diagnoses-icon',
      },
      {
        name: 'Services',
        action: '',
        icon: 'type-services-icon',
      },
      {
        name: 'Breeds',
        action: '',
        icon: 'dog-icon',
      },
      {
        name: 'Subscription Plans',
        action: '',
        icon: 'type-services-icon',
        roles: ['Administrator'],
      },
    ],
  },
];
